"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCEPTED = 'accepted';
exports.ACCESS_REQUESTED = 'accessRequested';
exports.ACTIONED = 'actioned';
exports.APPROVED = 'approved';
exports.CANCELLED = 'cancelled';
exports.CHAT_CREATED = 'chatCreated';
exports.CHAT_ENDED = 'chatEnded';
exports.CHECKED_IN = 'checkedIn';
exports.COMMENTED = 'commented';
exports.COMPLETE = 'complete';
exports.CREATED = 'created';
exports.DELETED = 'deleted';
exports.DISMISSED = 'dismissed';
exports.ENDED = 'ended';
exports.FILE_ADDED = 'fileAdded';
exports.FILE_REMOVED = 'fileRemoved';
exports.GRANTED = 'granted';
exports.HEARTED = 'hearted';
exports.HIDDEN = 'hidden';
exports.MEMO_CREATED = 'memoCreated';
exports.MEMO_SHARED = 'memoShared';
exports.PENDING = 'pending';
exports.PROCESSING = 'processing';
exports.PREVIEW = 'preview';
exports.REJECTED = 'rejected';
exports.RESENT = 'resent';
exports.REMOVED = 'removed';
exports.SHARED = 'shared';
exports.STARTED = 'started';
exports.UNSHARED = 'unshared';
exports.UPDATED = 'updated';
exports.URL_ADDED = 'urlAdded';
exports.URL_REMOVED = 'urlRemoved';
exports.VIEWED = 'viewed';
exports.FILE_SAVED = 'fileSaved';
exports.PUBLIC_SHARED = 'publicShared';
exports.PUBLIC_UNSHARED = 'publicUnshared';
exports.PUBLIC_VIEWED = 'publicViewed';
exports.REMINDERS_CANCELLED = 'remindersCancelled';
exports.REMINDERS_SCHEDULED = 'remindersScheduled';
exports.REPORTED = 'reported';
